<script lang="ts">
	//Design system components
	import { Text, AdvancedCardV2, ProgressBar } from '@Shelly/shelly-design-system';
	import { translateTemplateTitle } from 'src/helpers/xt1_helpers/template_helpers';
	//Types
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let status: VCInterfaceStatus;

	let min = Number(status.config?.min ?? 0);
	let max = Number(status.config?.max ?? 100);
	const valueToPercent = (value: number, min: number, max: number) => {
		return ((value - min) * 100) / (max - min);
	};
</script>

<AdvancedCardV2 title="" class="mb-s">
	<div slot="main" class="d-flex flex-direction-column width-full" style="pointer-events:none;">
		<ProgressBar
			class="mt-l width-full"
			type="primary"
			progress={valueToPercent(status.rawValue, min, max)}
		/>
		<Text styleType="body-small" class="mt-s mb-s text-center text-bold"
			>{translateTemplateTitle(status.name) + ' ' + status.value}</Text
		>
	</div>
</AdvancedCardV2>
